const quotes = [
  "Decision-Ready Reports That Fuel Consistent Growth & ROI",
  "Page-by-Page, Rigorously Fact-Checked Reports.",
  "Here is where Trusted Quality Data Meets Consistent Growth & ROI.",
  "100% Accuracy, 0% Guesswork—Every Report, Every Time.",
  "We make data reveal exactly what you need—your way, every time",
  "Contextual Clarity, Page by Page, Insight by Insight.",
  "Data speaks volumes. Perceive Now translates.",
  "Decision-Ready Insights, delivered in hyper-customizable reports.",
  "AI Transparency you can trust, down to the last detail.",
  "Your Business Moves Fast. So Do We—Decision-Ready Insights in 48 Hours.",
  "Data with Integrity—No Fluff, No Hallucinations, Just Facts.",
  "Trusted Intel Beyond Limits—Driven by Agentic AI.",
  "The Power to Know, The Confidence to Act, by our Agentic AI",
  "AI with Purpose—Meet our Agentic AI.",
  "No Black Box, Just Clear AI Transparency."
];

export default quotes;